import React from 'react';
import sAction from 'sAction';
import MicrosoftButton from 'ROOT/src/components/formElements/MicrosoftButton';
import PropTypes from 'prop-types';

export default function SSOSetupLogin(props) {
    /**
     *
     */
    const setupSSOViaMicrosoft = () => {
        sAction.setStorage('SETUP_ENFORCED_MICROSOFT_SSO_LOGIN', props.token);
        sAction.usrMsgraphSignIn('_self', true);
    };

    return (
        <div className={'SSOCard'}>
            <div className={'SSOCard__header'}>
                <div className="SSOCard__title">
                    {sAction.translate('LBL_SSO_TITLE')}
                </div>
                <div
                    className="SSOCard__subtitle"
                    dangerouslySetInnerHTML= {{__html: sAction.translate('LBL_SSO_SUBTITLE')}}
                />
            </div>
            <div className={'SSOCard__body'}>
                <MicrosoftButton
                    className={'w100'}
                    onClick={setupSSOViaMicrosoft}
                    label={sAction.translate('LBL_SSO_MICROSOFT_CONNECT')}
                />
                <div className={'loginLinkGrid'}>
                    <div className={'loginRow loginLinks'}>
                        <div
                            className={'backToLoginLink'}
                            onClick={props.goToLogin}
                        >
                            {sAction.translate('LBL_BACK_TO_LOGIN')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

SSOSetupLogin.propTypes = {
    token: PropTypes.string.isRequired,
    goToLogin: PropTypes.func,
};
